import { styled } from "@acko-tech/building-blocks.ui.common";
import { device } from "@utils/screens";

export const Container = styled.div`
  height: max-content;
  width: 100%;
`;

export const SelectedAddress = styled.div`
  padding: 20px 32px;
  position: relative;

  @media ${device.tablet} {
    padding: 20px;
  }
`;

export const Title = styled.p`
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 15px;
  text-align: left;
  margin: 0;
  color: #000;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const Description = styled.p`
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  margin: 0;
  color: #5b5675;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DetectLocationContainer = styled.div`
  font-weight: 500;
  width: max-content;
  font-size: 14px;
  color: #1b73e8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px auto;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  left: 50px;
  right: 50px;
  border-radius: 52px;
  background: #fff;
  box-shadow: 0px 4px 8px -2px rgba(54, 53, 76, 0.06);
  padding: 8px 14px;
  z-index: 2;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
`;

export const CurrentLocationText = styled.span`
 color: var(--Text-Primary-grey600, #121212);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const MapWrapper = styled.div`
  position: relative;
  height: 353px;
  width: 100%;

  @media ${device.tablet} {
    height: calc(100vh - 50px - 64px - 72px - 135px);
  }
`;

export const InputContainer = styled.div`
  position: absolute;
  top: 20px;
  left: 32px;
  right: 32px;
  width: calc(100% - 64px);
  display: flex;

  @media ${device.tablet} {
    left: 20px;
    right: 20px;

    width: calc(100% - 40px);
  }
`;

export const Input = styled.input`
  border: 1px solid #d6d9e0;
  border-radius: 8px;
  padding: 14px 0 14px 14px;
  font-size: 14px;
  width: 100%;
  height: 100%;
  outline: none;
  text-transform: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;

  ::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #5b5675;
    text-transform: none;
  }
`;

export const MapMarker = styled.div`
  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  width: max-content;
  height: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  background-color: #e7e7f0;
  height: 5px;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ProgressBarContainerBlock = styled.div`
  width: 0%;
  height: 100%;
  background-color: #7c47e1;
  transition: width 2s linear; /* note this line */
`;

export const ChangeButton = styled.button`
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #E8E8E8;
  background: #FFF;
  cursor: pointer;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  color: #000;
  white-space: nowrap;
`;
